import gsap from "gsap";
import teamlist from "../../../_inc/parts/character/teamlist.json";


export default class Archive {

    constructor() {
        this.nowTeamClass = '';
        this.init();
    }

    init() {
        this.mouseEvent();
        this.teamChange();
    }

    mouseEvent() {
        
        $(document).on("mouseenter", ".js-hovermember", function () {
            if (window.innerWidth <= 768) {
                return;
            }
            const tgt = $(this).attr("data-target");
            $(".team__member__ph").addClass("-active");
            $(".team__member__ph" + ".-" + tgt).removeClass("-active");
        });

        $(document).on("mouseleave", ".js-hovermember", function () {
            $(".team__member__ph").removeClass("-active");
        });   
    }

    teamChange() {
        let index = 0;
        const teamArr = teamlist.map((el) => (el.id === "1nm8" ? `#t_${el.id}` : `#${el.id}`));

        const change_anim = (tgt) => {
            $(tgt).addClass("-active");

            const tl = gsap.timeline();

            tl.fromTo(".team__pagenate", { duration: 0.5, rotation: "180deg" }, { rotation: "0deg" }, 0);
            tl.fromTo(tgt + " .team__bg", { duration: 0.6, width: "0%" }, { width: "100%", ease: "Circ.easeInOut" }, 0.3);
            tl.fromTo(tgt + " .team__info_wrap", { duration: 0.6, opacity: 0, y: 50 }, { opacity: 1, y: 0, ease: "Circ.easeOut" }, 0.3);

            tl.fromTo(tgt + " .team__catch", { duration: 0.6, opacity: 0 }, { opacity: 1 }, 0.6);
            tl.fromTo(tgt + " .team__typebg", { duration: 0.6, opacity: 0, x: -50 }, { opacity: 1, x: 0, ease: "Circ.easeOut" }, 0.6);
            tl.fromTo(tgt + " .team__member__ph", { duration: 0.2, opacity: 0, scale: 0.98 }, { stagger: 0.1, opacity: 1, scale: 1 }, 0.6);
        };

        const setNav = () => {
            const prev = index == 0 ? teamArr[teamArr.length - 1] : teamArr[index - 1];
            const next = index == teamArr.length - 1 ? teamArr[0] : teamArr[index + 1];

            $(".team__pagenate__item.-prev").attr("href", prev);
            $(".team__pagenate__item.-next").attr("href", next);

            $(".teamnav__item").removeClass("-active");
            $(".team").removeClass("-active");

            $(".teamnav__item").eq(index).addClass("-active");
        };

        const setProf = (tgt) => {
            $(`${tgt} .js-btnProf`).on("click", () => {
                if ($(`${tgt} .js-prof`).hasClass("-active")) return;
                $(`${tgt} .js-prof`).addClass("-active");
            });

            $(`${tgt} .js-profClose`).on("click", () => {
                $(`${tgt} .js-prof`).removeClass("-active");
            });
        };

        const setDOM = (tgt) => {
            //DOMがない場合、getして親要素に追加する
            if ($(tgt).length == 0) {
                const filename = tgt.replace("#", "") + ".html";
                const fileVersion = "";

                $.ajax({
                    url: "../_inc/parts/character/team/" + filename + fileVersion,
                    type: "GET",
                    dataType: "html",
                }).done(function (data) {
                    $(".character_archive__teams").append(data);
                    change_anim(tgt);
                    setProf(tgt);
                });
            } else {
                //すでに存在する場合
                change_anim(tgt);
                $(`.js-prof`).removeClass("-active"); //cleanup
            }
        };

        //hashchangeでアニメーション
        $(window).on("load hashchange", ()=>{
            let tgt = location.hash == "" ? "#bae" : location.hash;

            if(this.nowTeamClass != ''){
                document.body.classList.remove(`-${this.nowTeamClass}`);
                document.querySelector(`.-item_${this.nowTeamClass}`).classList.remove('-current');
            }

            this.nowTeamClass = `${tgt.replace(/#/g, '')}`;
            document.body.classList.add(`-${this.nowTeamClass}`);
            document.querySelector(`.-item_${this.nowTeamClass}`).classList.add('-current');

            //今のインデックスを決定
            for (let i = 0; i <= teamArr.length; i++) {
                if (tgt == teamArr[i]) {
                    index = i;
                    break;
                }
            }

            //ナビのセット
            setNav();

            //DOMの挿入とアニメーション
            setDOM(tgt);
        });
    }
}
